import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { useLocation } from 'react-router-dom';
import { GetActivePopups } from '@fci/business-layer/services/popups';
import storage from '@fci/business-layer/storage';
import { token } from '@fci/business-layer/constants';
import moment from 'moment';
import HomeActivePopups from './HomeActivePopups';

const seenHomePopupIdsKey = 'seen_home_popup_ids_pwa';

const GlobalActivePopups = () => {
    const location = useLocation();
    const isAuth = !!storage.getItem(token);
    const { data: activePopupsResult, refetch } = useQuery(GetActivePopups, {
        fetchPolicy: 'network-only',
        skip: !isAuth || location.pathname === '/login'
    });
    const [activePopups, setActivePopups] = useState([]);
    const [showPopupList, setShowPopupList] = useState(false);

    const applyVisiblePopups = useCallback((items) => {
        const seenIds = JSON.parse(localStorage.getItem(seenHomePopupIdsKey) || '[]');
        const seenIdSet = new Set((Array.isArray(seenIds) ? seenIds : []).map(item => `${item}`));
        const path = location.pathname;

        const unseenItems = items.filter(item => {
            const isSeen = seenIdSet.has(`${item?.id}`);

            let isTimeValid = true;
            if (item.startDate) {
                isTimeValid = isTimeValid && moment().isAfter(moment.utc(item.startDate));
            }
            if (item.endDate) {
                isTimeValid = isTimeValid && moment().isBefore(moment.utc(item.endDate));
            }

            // Targeted location check
            let isLocationValid = true;
            if (item.targetLocation) {
                const currentPath = location.pathname.replace(/\/$/, '');
                const targets = item.targetLocation.split(/<br\s*\/?>\r?\n/).map(t => t.trim().replace(/\/$/, ''));
                isLocationValid = targets.includes(currentPath);
            }

            return !isSeen && isTimeValid && isLocationValid;
        });

        setActivePopups(unseenItems);
        setShowPopupList(false);
    }, [location.pathname]);

    const displayPopupList = (isVisible) => {
        setShowPopupList(isVisible);
        if (isVisible && activePopups.length > 0) {
            const seenIds = JSON.parse(localStorage.getItem(seenHomePopupIdsKey) || '[]');
            const seenIdSet = new Set((Array.isArray(seenIds) ? seenIds : []).map(item => `${item}`));
            const updatedSeenIds = [...new Set([
                ...seenIdSet,
                ...activePopups.map(item => `${item?.id}`)
            ])];
            localStorage.setItem(seenHomePopupIdsKey, JSON.stringify(updatedSeenIds));
        }
    }

    useEffect(() => {
        if (activePopupsResult && activePopupsResult.activePopups) {
            applyVisiblePopups(activePopupsResult.activePopups.results ?? []);
        }
    }, [activePopupsResult, location.pathname, applyVisiblePopups]);

    useEffect(() => {
        const path = location.pathname;
        const popupPaths = [
            '/',
            '/events',
            '/education',
            '/my-events',
            '/news'
        ];
        // Check if path starts with any of the popupPaths (to handle detail pages too)
        const shouldRefresh = popupPaths.some(p => path === p || path.startsWith(p + '/'));

        if (shouldRefresh) {
            refetch();
        }
        console.log('location.pathname', location.pathname)
    }, [location.pathname, refetch]);

    const canClosePopup = useMemo(() => activePopups.every(item => item?.isClosable !== false), [activePopups]);

    console.log('activePopups', activePopups)
    console.log('activePopupsResult', activePopupsResult)
    if (activePopups.length === 0) return null;

    return (
        <HomeActivePopups
            activePopups={activePopups}
            showPopupList={showPopupList}
            canClosePopup={canClosePopup}
            setShowPopupList={displayPopupList}
            setActivePopups={setActivePopups}
        />
    );
};

export default GlobalActivePopups;
